import React from 'react';
import { FadeIn } from './Shared';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  location: string;
}
const TestimonialCard = ({
  quote,
  author,
  location
}: TestimonialProps) => <div className="bg-navy-900/40 p-6 md:p-8 rounded-2xl border border-white/10 relative h-full flex flex-col hover:border-white/20 transition-colors" data-id="element-335">
    <Quote className="absolute top-6 right-6 w-8 h-8 text-pink-500/10" data-id="element-336" />
    <div className="text-pink-400 mb-5 text-xs flex gap-1" data-id="element-337">
      {[...Array(5)].map((_, i) => <span key={i} data-id="element-338">⭐</span>)}
    </div>
    <p className="text-base md:text-lg text-gray-100 font-sans mb-6 relative z-10 flex-grow leading-relaxed opacity-95" data-id="element-339">
      "{quote}"
    </p>
    <div className="border-t border-white/5 pt-5 mt-auto" data-id="element-340">
      <div className="font-bold text-white tracking-wide text-sm mb-1 font-sans" data-id="element-341">
        {author}
      </div>
      <div className="text-[10px] md:text-[11px] text-gray-400 font-bold uppercase tracking-wider font-sans" data-id="element-342">
        {location}
      </div>
    </div>
  </div>;
export const Testimonials = () => {
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden" data-id="element-343">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(236,72,153,0.03),transparent_70%)] pointer-events-none" data-id="element-344"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-345">
        <FadeIn data-id="element-346">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-347">
            <TestimonialCard quote="La primera semana de aplicar el Tomo I el 80% de mis consultas terminaron en turno confirmado con seña. El Script Maestro funciona de verdad." author="Valeria G." location="Manicura · Palermo, CABA" data-id="element-348" />
            <TestimonialCard quote="Por fin entendí por qué me dejaban en visto después de dar el precio. El Tomo I me lo explicó todo y en 4 días cambié cómo respondía. Los cierres se duplicaron." author="Lucas M." location="Lashista · Villa Crespo, CABA" data-id="element-349" />
            <TestimonialCard quote="Pensé que el problema era el precio. El Tomo II me cambió la cabeza. Ahora sé que era yo sin sistema para cobrar la seña." author="Sofía R." location="Esteticista · San Isidro, GBA" data-id="element-350" />
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const MoreTestimonials = () => {
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-351">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-352">
        <FadeIn data-id="element-353">
          <div className="flex flex-col items-center mb-16" data-id="element-354">
            <div className="bg-pink-500/10 text-pink-400 px-6 py-2 rounded-full border border-pink-500/20 text-xs font-bold tracking-[0.2em] mb-6 uppercase font-sans" data-id="element-355">
              HISTORIAS REALES
            </div>
            <h2 className="text-3xl md:text-5xl text-center text-white leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-356">
              ❤️ MÁS PROFESIONALES QUE YA LO TIENEN
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-357">
            <TestimonialCard quote="El Script Maestro me cambió todo. Antes de tenerlo cada consulta era una ruleta rusa. Ahora sé exactamente qué decir y el 70% termina en turno con seña." author="Cecilia R." location="Lashista · Mendoza · Método Turnos Blindados + Expansión Pro" data-id="element-358" />
            <TestimonialCard quote="El Bono 2 me salvó. Tenía dos clientas habituales que nunca querían pagar la seña. Con el árbol de decisión supe exactamente cómo responder a cada una sin ceder ni perderlas." author="Roberto M." location="Esteticista · Buenos Aires · Método Turnos Blindados" data-id="element-359" />
            <TestimonialCard quote="Expansión Pro me hizo entender que el problema no era que las clientas no querían pagar más. Era que yo no sabía cómo comunicar el valor de lo que hacía. La calculadora de rentabilidad me mostró que estaba cobrando el 18% de margen. Lo subí al 47% en dos meses." author="Sofía C." location="Manicura · La Plata · Método + Expansión Pro" data-id="element-360" />
            <TestimonialCard quote="El Tomo IV sobre reactivación me voló la cabeza. Con los 3 mensajes de reactivación recuperé 6 clientas inactivas en un mes. Eso fue $180.000 que antes estaban dormidos en mi teléfono." author="Pablo A." location="Cejas · Neuquén · Método Turnos Blindados" data-id="element-361" />
            <TestimonialCard quote="Mi agenda pasó del 65% al 92% de ocupación en el primer mes. No conseguí clientas nuevas. Apliqué el sistema con las que ya tenía." author="Daniela M." location="Manicura y Lashes · Rosario · Método Turnos Blindados" data-id="element-362" />
          </div>
        </FadeIn>
      </div>
    </section>;
};